/**
 * В данном файле хранится весь функционал для аналитики Detectum
 * ФУНКЦИИ ИЗ ФАЙЛА НЕ ПЕРЕИСПОЛЬЗОВАТЬ
 * нужна была кастомная логика для присвоения значения default
 * те если пользователь не посещал на нашем сайте поиск или эксплор, то значение должно быть отправлено default
 * @see https://leveltravel.atlassian.net/browse/LT-38432
 */
import { isSSR } from 'src/helpers/ssr';
import { getFlagSigmaHasAnOption } from '..';

const DETECTUM_KEY_LOCAL_STORAGE = 'lt-visited-search-v2';
const DETECTUM_VALUE_LOCAL_STORAGE = 'visit';
const IS_DETECTUM =
  getFlagSigmaHasAnOption('abDetectum', 'detectum_1') ||
  getFlagSigmaHasAnOption('abDetectum', 'detectum_2');

/**
 * Использовать данную функцию для аналитики на страницах:
 * Search и SeoPage
 */
export const getValueForExperimentDetectumVsRecommenderSearchPages =
  async (): Promise<
    'default' | 'detectum_1' | 'detectum_2' | 'recommender_1' | 'recommender_2'
  > => {
    if (isSSR) {
      return 'default';
    }

    const isDetectum = await IS_DETECTUM;

    localStorage.setItem(
      DETECTUM_KEY_LOCAL_STORAGE,
      DETECTUM_VALUE_LOCAL_STORAGE,
    );

    if (isDetectum === undefined) {
      return 'default';
    }

    if (await getFlagSigmaHasAnOption('abDetectum', 'detectum_1')) {
      return 'detectum_1';
    }

    if (await getFlagSigmaHasAnOption('abDetectum', 'detectum_2')) {
      return 'detectum_2';
    }

    if (await getFlagSigmaHasAnOption('abDetectum', 'recommender_1')) {
      return 'recommender_1';
    }

    if (await getFlagSigmaHasAnOption('abDetectum', 'recommender_2')) {
      return 'recommender_2';
    }

    return 'default';
  };

/**
 * Использовать данную функцию для аналитики на остальных страницах
 */
export const getValueForExperimentDetectumVsRecommenderOtherPages =
  async (): Promise<
    'default' | 'detectum_1' | 'detectum_2' | 'recommender_1' | 'recommender_2'
  > => {
    if (isSSR) {
      return 'default';
    }
    const isDetectum = await IS_DETECTUM;
    const isSearchVisited =
      localStorage.getItem(DETECTUM_KEY_LOCAL_STORAGE) ===
      DETECTUM_VALUE_LOCAL_STORAGE;
    if (isDetectum === undefined || !isSearchVisited) {
      return 'default';
    }

    if (await getFlagSigmaHasAnOption('abDetectum', 'detectum_1')) {
      return 'detectum_1';
    }

    if (await getFlagSigmaHasAnOption('abDetectum', 'detectum_2')) {
      return 'detectum_2';
    }

    if (await getFlagSigmaHasAnOption('abDetectum', 'recommender_1')) {
      return 'recommender_1';
    }

    if (await getFlagSigmaHasAnOption('abDetectum', 'recommender_2')) {
      return 'recommender_2';
    }

    return 'default';
  };
